import styled from 'styled-components'

export const Link = styled.a`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  color: #3a64f8;
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  transition: color 200ms linear 0s;

  &:hover {
    color: #6b8bfa;
  }
`
